/* eslint-disable react/no-unescaped-entities */
import { useState } from 'react';
import { Accordion, AccordionHeader, AccordionBody } from '@material-tailwind/react';

function Icon({ id, open }) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      className={`${id === open ? 'rotate-180' : ''} h-5 w-5 transition-transform`}
      fill='none'
      viewBox='0 0 24 24'
      stroke='currentColor'
      strokeWidth={2}
    >
      <path strokeLinecap='round' strokeLinejoin='round' d='M19 9l-7 7-7-7' />
    </svg>
  );
}

export const FaqAccordion = ({ faqs, className }) => {
  const [open, setOpen] = useState(null);

  const handleOpen = (value) => {
    setOpen(open === value ? null : value);
  };

  return (
    <div className={className ?? 'flex flex-col gap-4'}>
      {faqs.map((faq, i) => {
        const { question, answer, id } = faq;
        return (
          <Accordion
            key={`faq-${id}`}
            className='h-fit overflow-hidden rounded-lg border border-jacarta-100 dark:border-jacarta-600'
            open={open === i}
            icon={<Icon id={i} open={open} />}
          >
            <AccordionHeader
              className={
                'accordion-button relative flex w-full items-center justify-between border-b !border-b-jacarta-100 bg-white px-4 py-3 text-left font-display text-[18px] text-jacarta-700 transition-all duration-300 dark:border-jacarta-600 dark:bg-jacarta-700 dark:text-white' +
                (open === i ? '' : ' rounded-b-lg')
              }
              onClick={() => handleOpen(i)}
            >
              {question}
            </AccordionHeader>
            <AccordionBody
              className={
                'accordion-body h-full bg-white p-4 text-base font-normal leading-[22px] dark:bg-jacarta-700 dark:text-jacarta-100'
              }
            >
              <div dangerouslySetInnerHTML={{ __html: answer }} />
            </AccordionBody>
          </Accordion>
        );
      })}
    </div>
  );
};
